import React from 'react'
import { Col, RadioInput, Row } from '@olxbr/design-system'

const DocumentTypeSelection = ({ documentType, disabled, onChange }) => {
  return (
    <Row>
      <Col size="50">
        <RadioInput
          checked={documentType === 'cpf'}
          label="Pessoa Física"
          name="conta-pf"
          aria-label="Pessoa Física"
          onChange={onChange}
          value="cpf"
          disabled={disabled}
        />
      </Col>
      <Col size="50" padding="0">
        <RadioInput
          checked={documentType === 'cnpj'}
          label="Pessoa Jurídica"
          aria-label="Pessoa Jurídica"
          name="conta-pj"
          onChange={onChange}
          value="cnpj"
          disabled={disabled}
        />
      </Col>
    </Row>
  )
}

export { DocumentTypeSelection }
